import { jsxs, jsx } from 'react/jsx-runtime';

function LoadingIndicator(_ref) {
  let {
    variant = 'ring',
    label,
    className
  } = _ref;
  return jsxs("div", {
    className: "lds-container ".concat(className ? className : ''),
    children: [jsxs("div", {
      className: "lds-".concat(variant),
      children: [jsx("div", {}), jsx("div", {}), jsx("div", {}), jsx("div", {})]
    }), label ? jsx("div", {
      className: "lds-label",
      children: label
    }) : null]
  });
}

export { LoadingIndicator };
